import { RoleTypeEnum } from '@shared/models/role-type';

export type DoctorsEditWebSessionParams = Readonly<{
	userRole: RoleTypeEnum;
	isReadOnly: boolean;
	isHeadlessPrint: boolean;
	isScanner: boolean;
}>;

export const isDoctorsEditWebSession = (params: DoctorsEditWebSessionParams): boolean => {
	const { userRole, isReadOnly, isHeadlessPrint, isScanner } = params;

	return !isScanner && userRole === RoleTypeEnum.Doctor && !isReadOnly && !isHeadlessPrint;
};
